import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "InfoRequest" })
export default class InfoRequest extends Vue {
    public localizer: any = Localizer;
    public isLoading: boolean = false;
    public isSuccess: boolean = false;
    public isPrivacyPolicyShow: boolean = false;
    public privacyPolicy: string = null;
    public formData: any = { country: null, zone: null };
    public validationErrors: any[] = [];
    public countries: any[] = [];
    public provinces: any[] = [];

    @Prop() readonly recaptchaSiteKey: string;
    @Prop() readonly message: string;
    @Prop() readonly requestUrl: string;
    @Prop() readonly isDialog: string;

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        const result = (await Axios.post(this.routes.Support_GetInfoRequestData, null)).data;
        this.countries = result.countries;
        this.provinces = result.provinces;

        if (this.message) {
            this.formData.message = this.message;
        }

        this.setRecaptcha();
    }

    public setRecaptcha() {
        let recaptchaScript = document.createElement("script");
        recaptchaScript.setAttribute("src", "https://www.recaptcha.net/recaptcha/api.js");
        document.head.appendChild(recaptchaScript);
    }

    public async showPrivacyPolicy() {
        this.isPrivacyPolicyShow = !this.isPrivacyPolicyShow;

        if (!this.privacyPolicy) {
            let response = await Axios.post(this.routes.Terms_GetPrivacyPolicyInfoRequest);

            this.privacyPolicy = Object.freeze(response.data.description);
        }
    }

    public setCountryType() {
        this.formData.zone = null;
    }

    public async submitForm() {
        this.validationErrors = [];

        this.isLoading = true;

        this.formData.requestUrl = this.requestUrl;

        try {
            await Axios.post(this.routes.Support_InfoRequest, this.formData, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken(), "RecaptchaVerificationToken": (<any>window).grecaptcha.getResponse() } });

            this.isSuccess = true;

            GTagHelper.sendEvent("form_submit", "info_request");
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }

            (<any>window).grecaptcha.reset();
        }

        this.isLoading = false;
    }

    public isValidationError(controlName: string): boolean {
        return FormHelper.isControlValidationError(controlName, this.validationErrors);
    }

    public closeDialog() {
        this.$emit("closeDialog");
    }
};